// 文件导出
export function downloadBlobFile(res, name) {
    const blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'});
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //msSaveOrOpenBlob：提供保存和打开按钮
        const fileName = name + '.xlsx';
        window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
        const fileName = name + '.xlsx';
        const elink = document.createElement('a');
        elink.style.display = 'none';
        //elink.href = URL.revokeObjectURL(blob);
        elink.href = URL.createObjectURL(blob);
        elink.download = fileName;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
    }
}

// 时间格式化
export function dateFormat(date, format) {
  date = new Date(date);
  // date.setHours(date.getHours() - 14);
  var o = {
    'M+': date.getMonth() + 1, //month
    'd+': date.getDate(), //day
    'H+': date.getHours(), //hour
    'm+': date.getMinutes(), //minute
    's+': date.getSeconds(), //second
    'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
    'S': date.getMilliseconds() //millisecond
  };

  if (/(y+)/.test(format))
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));

  for (var k in o)
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  return format;
}
